import { ICoreZonesInitialState } from "./types";

const initialState: ICoreZonesInitialState  = {
  displayZones: true,
};

export default initialState;